import type {Logger} from './types';

export class VoidLogger implements Logger {
    trace = noop;
    debug = noop;
    info = noop;
    warn = noop;
    error = noop;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
const noop = (...args: any[]) => {}